/**
 * Permission vocabulary, as issued with the access token at login
 * (`menu_permissions` on the login / MFA-verify response).
 *
 * A granted permission is identified by its `module` + `name` pair (e.g.
 * Provider + Create), and its menu is identified by the `menuType` id.
 * The backend's `code` field (`provider:create`) is deliberately NOT used
 * here — it exists for the backend's own checks.
 */

/** `menuType` ids — the module a permission belongs to. */
export enum MenuType {
  Dashboard = 1,
  User = 2,
  Role = 3,
  Claim = 4,
  Patient = 5,
  Provider = 6,
  Audit = 7,
  Bhs = 8,
  Cpt = 9,
  Claimdata = 10,
  Reports = 11,
  Settings = 12,
  BulkUpload = 13,
}

/** `module` values. */
export const PERMISSION_MODULE = {
  Dashboard: 'Dashboard',
  User: 'User',
  Role: 'Role',
  Claim: 'Claim',
  Patient: 'Patient',
  Provider: 'Provider',
  Audit: 'Audit',
  Bhs: 'Bhs',
  Cpt: 'Cpt',
  Claimdata: 'Claimdata',
  Reports: 'Reports',
  Settings: 'Settings',
  BulkUpload: 'BulkUpload',
} as const;

/** `name` values — the action within a module. */
export const PERMISSION_ACTION = {
  Create: 'Create',
  Read: 'Read',
  Update: 'Update',
  Delete: 'Delete',
  Invite: 'Invite',
  Unlock: 'Unlock',
  Export: 'Export',
  Verify: 'Verify',
} as const;

export type PermissionModule = (typeof PERMISSION_MODULE)[keyof typeof PERMISSION_MODULE];
export type PermissionAction = (typeof PERMISSION_ACTION)[keyof typeof PERMISSION_ACTION];
